import { trackEvent } from './tracking';

// Types
import { PiSuggestedTopicsCategories } from 'Shared/types/PiSuggestedTopic.type';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

export const useTrackPiSuggestedTopics = () => {
  const { app } = useApp();
  const { id: workspaceUuid, isOneOnOne, isGroup, isPersonal, isTeamSync } = useWorkspace();
  const { id: currentUserId, piUserGuid: currentPiUserId } = useCurrentUser();
  const appId = app.id;

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      app_id: appId,
      user: currentUserId,
      pi_user: currentPiUserId,
      workspaceUuid,
      isOneOnOne,
      isGroup,
      isPersonal,
      isTeamSync,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackTogglePanelOpen = ({ open }: { open: boolean }) => {
    track({
      eventName: 'Clicked PI Suggested Topics Panel',
      properties: { open },
    });
  };

  const trackChangedCategory = ({ category }: { category: string }) => {
    track({
      eventName: 'Changed PI Suggested Topic Category',
      properties: { category },
    });
  };

  const trackTopicAdded = ({ suggestion, category }: { suggestion: string; category: PiSuggestedTopicsCategories }) => {
    track({
      eventName: 'PI Suggested Topic Added',
      properties: { suggestion, category },
    });
  };

  const trackRefreshClick = () => {
    track({
      eventName: 'Clicked Refresh Suggested Topics',
    });
  };

  return {
    trackTogglePanelOpen,
    trackChangedCategory,
    trackTopicAdded,
    trackRefreshClick,
  };
};
